// extracted by mini-css-extract-plugin
module.exports = {"efCollapse":"collapse_efCollapse__Ojgai"};